export const TRANSLATION_REQUEST_STATUS_OPTIONS = [
  { value: 'Under Review', label: 'Under Review' },
  { value: 'Agreed – Permissioned', label: 'Agreed – Permissioned' },
  { value: 'Agreed – Commissioned', label: 'Agreed – Commissioned' },
  { value: 'Archived', label: 'Archived' }
];

const LEGACY_TRANSLATION_REQUEST_STATUS_MAP = {
  Pending: 'Under Review',
  Approved: 'Agreed – Permissioned',
  Granted: 'Agreed – Commissioned',
  Rejected: 'Archived'
};

export function normalizeTranslationRequestStatus(value) {
  if (!value) return 'Under Review';
  if (TRANSLATION_REQUEST_STATUS_OPTIONS.some((o) => o.value === value)) return value;
  return LEGACY_TRANSLATION_REQUEST_STATUS_MAP[value] || value;
}

export function translationRequestStatusBadgeClass(value) {
  const status = normalizeTranslationRequestStatus(value);
  if (status === 'Agreed – Permissioned' || status === 'Agreed – Commissioned') {
    return 'bg-green-100 text-green-800';
  }
  if (status === 'Under Review') return 'bg-blue-100 text-blue-800';
  if (status === 'Archived') return 'bg-gray-100 text-gray-800';
  return 'bg-gray-100 text-gray-800';
}
